// extracted by mini-css-extract-plugin
export var closeButton = "_7-1";
export var container = "_7-0";
export var fullModalImage = "_7-2";